import { render } from "./ListClients.vue?vue&type=template&id=5652f526"
import script from "./ListClients.vue?vue&type=script&lang=js"
export * from "./ListClients.vue?vue&type=script&lang=js"

import "./ListClients.vue?vue&type=style&index=0&id=5652f526&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__